<div id="extr-page" class ="auth_layout_sec">
    <div class="ellipse"></div>
    <router-outlet></router-outlet>
    </div>
    